module.exports = __webpack_public_path__ + "static/crystalHeart-19dda58b7040a2e26bb21ab8c95061aa.png";